import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Text from '../../../elements/Text';
import Icon from '../../../elements/Icon';
import { useTranslation } from '@front10/utils';

const LegendCalendar = (props) => {
  const {
    showCurrenciesType,
    legendBlackOutDays,
    showLegendBlackOutDays,
    columnLegendPriceSetting,
    columnLegendBlackOutDaysSetting,
    columnCurrenciesTypeSetting,
    columnCurrencyPriceDisclaimer,
    legendCirclePriceSettings = {},
    legendBlackOutDaysIcon = {},
    cheapestPriceText = {},
    legendCheckAvailability,
    legendCheckAvailabilityIcon,
    currencyPriceDisclaimer,
    checkAvailabilitylabelKey = 'cmp-legend-availability-check',
    showCheapestPriceText = true,
    highlightLowestPrices = false,
    showCurrencyPriceDisclaimer = false,
    currencyInDisclaimer = 'USD',
    isOneWayTrip
  } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const translate = useTranslation();

  return (
    <Row ariaHidden={true} className={`${className} fr-clearfix`} style={style} dataTestId="legend">
      {highlightLowestPrices && (
        <Col style={{ display: 'flex' }} {...columnLegendPriceSetting}>
          <Box
            style={{
              background: '#00855C',
              height: '12px',
              width: '12px',
              '-moz-border-radius': '50%',
              '-webkit-border-radius': '50%',
              'border-radius': '50%'
            }}
            {...legendCirclePriceSettings}
          ></Box>
          {showCheapestPriceText && (
            <Text {...cheapestPriceText}>{translate('cmp-legend-cheapest-price', 'Cheapest')}</Text>
          )}
        </Col>
      )}
      {showLegendBlackOutDays && (
        <Col style={{ display: 'flex' }} {...columnLegendBlackOutDaysSetting}>
          <Icon
            ariaHidden={true}
            icon="close-material"
            size="20"
            {...legendBlackOutDaysIcon}
          ></Icon>
          <Text {...legendBlackOutDays} floatLeft marginRight="1">
            {translate('cmp-legend-black-out-days', 'Black out days')}
          </Text>
        </Col>
      )}
      {showCurrenciesType && (
        <Col style={{ display: 'flex' }} {...columnCurrenciesTypeSetting}>
          <Icon ariaHidden={true} icon="searchV2" size="18" {...legendCheckAvailabilityIcon}></Icon>
          <Text {...legendCheckAvailability} floatLeft marginRight="1">
            {translate(checkAvailabilitylabelKey, 'Check Availabilty')}
          </Text>
        </Col>
      )}
      {showCurrencyPriceDisclaimer && (
        <Col style={{ display: 'flex' }} {...columnCurrencyPriceDisclaimer}>
          <Text {...currencyPriceDisclaimer} floatRight marginRight="1">
            {isOneWayTrip
              ? translate(
                  'cmp-currency-price-disclaimer-ow',
                  '*Prices shown are total in {currencyToDisplay} per person, one way',
                  { currencyToDisplay: currencyInDisclaimer }
                )
              : translate(
                  'cmp-currency-price-disclaimer-rt',
                  '*Prices shown are total in {currencyToDisplay} per person, round-trip',
                  { currencyToDisplay: currencyInDisclaimer }
                )}
          </Text>
        </Col>
      )}
    </Row>
  );
};

LegendCalendar.propTypes = {
  /**
   * Props of legendPrice
   */
  legendPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of BlackOutDays
   */
  legendBlackOutDays: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of CurrenciesType
   */
  legendCurrenciesType: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showLegendPrice item
   */
  showLegendPrice: PropTypes.bool,
  /**
   * Turn off or on the LegendBlackOutDays item
   */
  showLegendBlackOutDays: PropTypes.bool,
  /**
   * Turn off or on the CurrenciesType item
   */
  showCurrenciesType: PropTypes.bool
};

LegendCalendar.defaultProps = {
  legendPrice: {},
  legendBlackOutDays: {},
  legendCurrenciesType: {},
  showLegendPrice: true,
  showLegendBlackOutDays: true,
  showCurrenciesType: true
};

export default LegendCalendar;
